<app-orders-table
  [dataSource]="dataSource"
  [orderState]="OrderStateEnum.StagedAssignment"
  [warehouses]="warehouses"
  [businesses]="businesses"
  [displayedColumns]="displayedColumns"
  (tableActionTaken)="handleTableAction($event)"
></app-orders-table>